/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { CapabilityCardRenderer } from './CapabilityCardRenderer';

const CapabilityCardPortalPreview = ({
  componentId,
  componentClass,
  isHorizontal = false,
  enableB2CRadius = false,
  portalPreviewData = null,
}) => {
  let { richTextContent } = portalPreviewData || {};

  return (
    <CapabilityCardRenderer
      componentId={componentId}
      componentClass={componentClass}
      isHorizontal={isHorizontal}
      enableB2CRadius={enableB2CRadius}
      dataComponent={portalPreviewData}
      richTextData={richTextContent?.json}
      isLivePreview
    />
  );
};

CapabilityCardPortalPreview.propTypes = {
  componentId: PropTypes.string.isRequired,
  componentClass: PropTypes.string.isRequired,
  isHorizontal: PropTypes.bool,
  enableB2CRadius: PropTypes.bool,
  portalPreviewData: PropTypes.shape({}),
};

export { CapabilityCardPortalPreview };